import { Observable } from 'rxjs';

import { FileQueryParams, ResultQueryParams, Results } from '../models/result.model';

export abstract class ResultUsecase {
  abstract get results$(): Observable<Results>;

  abstract listResults(params: ResultQueryParams): Observable<never>;
  abstract getFile(params: FileQueryParams): Observable<string>;

  abstract clearResults(): void;
}
